import { render, staticRenderFns } from "./_sboLogin.vue?vue&type=template&id=1616eba3&scoped=true&lang=pug&"
import script from "./_sboLogin.vue?vue&type=script&lang=js&"
export * from "./_sboLogin.vue?vue&type=script&lang=js&"
import style0 from "./_sboLogin.vue?vue&type=style&index=0&id=1616eba3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1616eba3",
  null
  
)

export default component.exports